import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { CardListCell } from 'src/app/components/pages-partials/card-list/card-list-cell';
import { CardListCellTypes } from 'src/app/components/pages-partials/card-list/card-list-cell-types.enum';
import { ActionCommandProgress } from 'src/app/interfaces/action-command';
import { TranslatePipe } from '@ngx-translate/core';
import { ProgressInfo } from 'src/app/services/action-command.service';

@Component({
    selector: 'app-command-progress-info',
    templateUrl: './command-progress-info.component.html',
    styleUrls: ['./command-progress-info.component.scss'],
    providers: [TranslatePipe],
    standalone: false
})
export class CommandProgressInfoComponent implements OnInit {

  public isCollapsed: boolean = true;

  @Input() commandProgress: ProgressInfo

  constructor(
    private datePipe: DatePipe,
    private translatePipe: TranslatePipe,
  ) { }

  ngOnInit(): void {
  }

  public childTableCells: CardListCell[] = [
    {
      title: '',
      iconResolver: (item: ActionCommandProgress) => { return this.getActionStatusIcon(item); },
      class: 'text-right dashb-cell',
      type: CardListCellTypes.icon,
    },
    {
      title: '',
      textResolver: (item: ActionCommandProgress) => this.translatePipe.transform('ESB_' + item.messageType),
      class: 'text-truncate dashb-cell',
      type: CardListCellTypes.text,

    },
    {
      title: '', //this.translatePipe.transform('BO_WO_COMPLETED'),
      textResolver: (item: ActionCommandProgress) => this.datePipe.transform(item.isCompleted ? item.completedDate : item.commandDate, 'yyyy-MM-dd HH:mm'),
      class: 'text-truncate text-right dashb-cell',
      type: CardListCellTypes.text,
    },

  ];

  get status(): string {
    if (this.commandProgress.progressInfo.isFailure || !!this.commandProgress.progressInfo.exception) return 'failed';
    if (this.commandProgress.progressInfo.isCompleted) return 'completed';
    return 'running';
  }

  public statusIcon(): string {
    return this.commandProgress.progressInfo.isSuccess ? 'health-icon-ok' :
      this.commandProgress.progressInfo.isFailure ? 'health-icon-error' : '';
  }

  private getActionStatusIcon(commandProgress: ActionCommandProgress): string {
    return commandProgress.isSuccess ? 'health-icon-ok' :
      commandProgress.isFailure ? 'health-icon-error' : '';
  }

}
